<template>
  <custom-popup
    v-model="dialog"
    :cons="{ title: 'خرید بسته' }"
    hide-confirm
    hide-overlay
    max-width="500"
    transition="dialog-bottom-transition"
    @close="discountField = { show: false, model: '' }"
  >
    <div key="prices" class="pa-4">
      <custom-tabs
        v-model="tabs"
        :tab-items="prices"
        :window-items="prices"
        fixed-tabs
      >
        <template v-slot:tab="{ tab }">
          {{ tab.name }}
        </template>

        <template v-slot:item="{ item }">
          <div class="pt-2 red--text">
            به مبلغ بسته خریداری شده ۱۰ درصد مالیات افزوده میشود!
          </div>

          <v-list-item class="overflow-hidden border pa-2 rounded mt-2">
            <v-list-item-icon class="position-relative align-self-center">
              <div
                class="border border-2 rounded-circle position-absolute p-6"
                style="top: 50%; transform: translateY(-50%); right: -4em"
              >
                <v-icon size="70">mdi-plus-box</v-icon>
              </div>
            </v-list-item-icon>

            <v-list-item-content class="ms-4">
              <v-list-item-title>
                <h3 v-if="!!item.time">
                  <v-icon color="amber">mdi-clock</v-icon>
                  {{ item.time | currency }}
                  <small>روزه</small>
                </h3>

                <h3 class="d-flex align-center">
                  <v-icon color="amber darken-3">mdi-wallet</v-icon>
                  <div class="d-inline-block mr-1">
                    <span
                      :class="
                        !!item.discount && !!Number(item.discount)
                          ? 'text-decoration-line-through grey--text d-inline-block mb-1'
                          : ''
                      "
                    >
                      {{ item.price | currency }}
                      <v-chip
                        v-if="!!item.discount && !!Number(item.discount)"
                        class="mr-2"
                        color="red"
                        dark
                        small
                      >
                        {{ item.discount }} %
                      </v-chip>
                    </span>
                    <template v-if="!!item.discount && !!Number(item.discount)">
                      <br />
                      {{ item | getDiscount | currency }}
                    </template>
                    <small>﷼</small>
                  </div>
                </h3>
              </v-list-item-title>
            </v-list-item-content>

            <v-list-item-action>
              <v-btn
                :disabled="discountField.show"
                :loading="loading"
                color="green lighten-2"
                @click="upgradeQr(item.id)"
              >
                خرید می‌کنم!
              </v-btn>
              <v-btn
                :loading="loading"
                class="mt-2 mx-auto"
                color="primary"
                outlined
                small
                @click="
                  [
                    (discountField.show = !discountField.show),
                    (priceId = item.id),
                  ]
                "
              >
                افزودن کد تخفیف
              </v-btn>
            </v-list-item-action>
          </v-list-item>
        </template>
      </custom-tabs>
    </div>

    <v-expand-transition>
      <div v-if="discountField.show" key="discount">
        <v-card-title>استفاده از کد تخفیف ؟</v-card-title>
        <v-card-text>
          <v-text-field
            v-model="discountField.model"
            clear-icon="mdi-close-circle-outline"
            clearable
            dense
            label="کد تخفیف"
            outlined
            prepend-inner-icon="mdi-percent-box"
          >
            <template v-slot:append-outer>
              <v-btn
                :loading="loading"
                class="mt-n1"
                color="green lighten-2"
                dark
                depressed
                @click="upgradeQr(priceId)"
              >
                ثبت
              </v-btn>
            </template>
          </v-text-field>
        </v-card-text>
      </div>
    </v-expand-transition>
  </custom-popup>
</template>

<script>
import { QrAxios } from "../../../../../main";
export default {
  name: "togetherAiUpgrade",

  props: {
    value: Boolean,
    currentPackage: Object,
  },

  data: () => ({
    tabs: null,
    discountField: {
      show: false,
      model: "",
    },
    prices: [],
    loading: false,
    priceId: null,
  }),

  mounted() {
    this.getPackages();
  },

  computed: {
    dialog: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
    computedCurrent: {
      get() {
        return this.currentPackage;
      },
      set(val) {
        this.$emit("update:currentPackage", val);
      },
    },
  },

  filters: {
    getDiscount(price) {
      let p = Math.floor((Number(price.discount) * price.price) / 100);

      return price.price - p;
    },
  },

  methods: {
    getPackages() {
      this.loading = true;

      QrAxios.get("/v1/pricing-packages")
        .then(({ data }) => {
          this.prices = data.pricing_packages;
          this.computedCurrent = data.user_data;
        })
        .finally(() => (this.loading = false));
    },
    upgradeQr(priceId) {
      this.loading = true;

      QrAxios.post(`/v1/order-package/${priceId}`, {
        discount_code: !!this.discountField.model
          ? this.discountField.model
          : undefined,
      })
        .then((response) => {
          this.dialog = false;

          this.$modal.success("موفقیت", "کیوآر شما با موفقیت ارتقا پیدا کرد.");
          this.getPackages();
        })
        .catch((reason) => {
          if (reason.response.status === 402)
            this.$modal.error(
              "خطا",
              "لطفا موجودی حساب خود را بررسی بفرمایید و بعدا، دوباره تلاش فرمایید."
            );
          else this.$modal.error("خطا", "خطا در تمدید کیوآر!");
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>

<style scoped></style>
